import common from "./common.json";
import nav from "./nav.json";
import tour from "./tour.json";
import account from "./account.json";
import header from "./header.json";
import reviews from "./reviews.json";
import dashboard from "./dashboard.json";
import auth from "./auth.json";
import email from "./email.json";
import campaigns from "./campaigns.json";
import popups from "./popups.json";
import chats from "./chats.json";
import shopify from "./shopify.json";
import wishlist from "./wishlist.json";
import upgrade from "./upgrade.json";
import help from "./help.json";
import publicNs from "./public.json";
import errors from "./errors.json";
import productTour from "./productTour.json";

export const enResources = {
    common,
    nav,
    tour,
    account,
    header,
    reviews,
    dashboard,
    auth,
    email,
    campaigns,
    popups,
    chats,
    shopify,
    wishlist,
    upgrade,
    help,
    public: publicNs,
    errors,
    productTour,
};
